import React, { useState, useRef, useEffect } from "react";
import { useHistory } from "react-router-dom";
import Footer from "../../components/Footer.js";
import HeaderTransprent from "../../components/HeaderTransprent.js";
import Heading from "../../components/ui/Heading.js";
import TagHeading from "../../components/ui/TagHeading.js";
import Button from "../../components/ui/Button.js";
import ButtonBorder from "../../components/ui/ButtonBorder.js";
import ButtonReadmore from "../../components/ui/ButtonReadmore.js";
import Different from "../../components/ui/Different.js";
import Methodology from "../../components/ui/Methodology.js";
import Stats from "../../components/ui/Stats.js";
import ContactForm from "../../components/ui/ContactForm.js";
import JsonData from "../Json/leadership.json";
// import { MdOutlineCheckCircleOutline, MdOutlineArrowForwardIos, MdOutlineArrowBackIos } from "react-icons/md";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";

const Home = () => {

  const formRef = useRef(null);
  const history = useHistory();

  // const handleClick = (field) => {
  //   history.push(field ? `/${field}` : "/");
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleScrollToForm = () => {
    formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const [activeIndex, setActiveIndex] = useState(0);
  const rightRefs = useRef([]);
  const rightScrollRef = useRef(null);

  useEffect(() => {
    if (!rightScrollRef.current) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActiveIndex(Number(entry.target.dataset.index));
          }
        });
      },
      {
        root: rightScrollRef.current,
        threshold: 0.6,
      }
    );

    rightRefs.current.forEach((el) => el && observer.observe(el));

    return () => observer.disconnect();
  }, []);

  const [activeTab, setActiveTab] = useState(JsonData.philosophyTabs[0].key);

  const activeContent = JsonData.philosophyTabs.find(
    (tab) => tab.key === activeTab
  );



  return (
    <>
      <div className="">

        <HeaderTransprent />
        <section className="bg-cover bg-no-repeat bg-center w-full py-20 h-auto bgpagecolor" style={{ backgroundImage: `url('/img/assets/home/executive-search-solutions.webp')`, }}>
          <div className="w-full h-full">
            <div className="flex md:flex-row flex-col gap-10 mx-auto px-4 xl:px-0  w-full 2xl:w-[80%] xl:w-11/12 md:h-[40rem] h-[35rem]">
              <div className="flex flex-col justify-center space-y-8 md:max-w-4xl my-auto pt-10 md:pt-0 md:pb-12 w-full h-full md:text-left text-center">
                <TagHeading className="textactive" text="EXECUTIVE SEARCH SOLUTIONS" />
                <Heading className="textwhite" text="Executive Search That Shapes Tomorrow’s Leadership" />
                <p className="md:text-lg text-base textwhite mt-5">Executive search that identifies leaders who drive performance, shape culture, and accelerate long-term growth.</p>
                <p className="md:text-base text-sm textwhite mt-5">Trusted by organizations building leadership for the next decade</p>
                <div className="flex flex-col md:flex-row items-center md:space-x-4 space-y-4 md:space-y-0">
                  <div className="flex justify-center md:justify-start items-center md:items-center gap-4 md:w-72 w-full">
                    <Button text="Book a Consultation" onClick={() => history.push("/contact-us")} />
                  </div>
                  <div className="flex justify-center md:justify-start items-center md:items-center gap-4 md:w-72 w-full">
                    <ButtonBorder text="Explore Our Methodology" onClick={handleScrollToForm} />
                  </div>
                </div>
              </div>

              {/* <div className="flex justify-center items-center w-full">
                <img data-aos="fade-left" src="/img/assets/home/agrpartners.webp" alt="agrpartners" className="z-0" />
              </div> */}
            </div>
          </div>
        </section>

        <section className="bg-white py-20">
          <div className="mx-auto w-full px-4 xl:px-0 xl:w-11/12 2xl:w-[80%]">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
              <div className="max-w-2xl">
                <Heading className="textblack" text="Executive Search That Shapes The Future Of Leadership" />
                <p className="mt-6 textblack max-w-md leading-relaxed"> We partner with organizations to identify, assess, and secure exceptional leaders who create lasting impact.</p>
                <div className="mt-8 flex justify-center md:justify-start items-center md:items-center gap-4 md:w-96 w-full">
                  <Button text="Explore Our Search Methodology" onClick={handleScrollToForm} />
                </div>
              </div>

              <div className="space-y-10">
                <div className="flex gap-6 items-start">
                  <div className="w-20 aspect-square flex items-center justify-center rounded-xl bg-red-50 shrink-0">
                    <img src="/img/assets/home/leadership-defines-organizational-destiny.svg" alt="Leadership Defines Destiny" className="w-12 h-12 object-contain" />
                  </div>
                  <div>
                    <h2 className="font-semibold text-xl md:text-2xl textblack mb-3">Leadership Defines Organizational Destiny</h2>
                    <p className="textblack text-sm md:text-base leading-relaxed">In a fast-changing world, organizations rise not because of systems alone — but because of the leaders who guide decisions, people, and direction.</p>
                  </div>
                </div>
                <div className="flex gap-6 items-start">
                  <div className="w-20 aspect-square flex items-center justify-center rounded-xl bg-red-50 shrink-0">
                    <img src="/img/assets/home/the-right-leader-changes-everything.svg" alt="Right Leader Transforms Organizations" className="w-12 h-12 object-contain" />
                  </div>
                  <div>
                    <h2 className="font-semibold text-xl md:text-2xl textblack mb-3">The Right Leader Changes Everything</h2>
                    <p className="textblack text-sm md:text-base leading-relaxed">The right leader turns strategy into action — unlocking performance, building trust, shaping culture, and accelerating growth in ways no structure alone can achieve.</p>
                  </div>
                </div>
                <div className="flex gap-6 items-start">
                  <div className="w-20 aspect-square flex items-center justify-center rounded-xl bg-red-50 shrink-0">
                    <img src="/img/assets/home/science-led-human-centered.svg" alt="Science Driven Leadership Search" className="w-12 h-12 object-contain" />
                  </div>
                  <div>
                    <h2 className="font-semibold text-xl md:text-2xl textblack mb-3">Science-Led. Human-Centered.</h2>
                    <p className="textblack text-sm md:text-base leading-relaxed">We blend leadership psychology, human behaviour, and business insight to ensure every executive search decision is built for tomorrow — not just today.</p>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </section>

        {/* Stats Section */}
        <Stats />

        {/* Services */}
        <section className="bg-[#9B26350F] textwhite py-20">
          <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-[80%] xl:w-11/12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-16">
              <div>
                <TagHeading className="textactive" text="Services" />
                <Heading className="textblack" text="Explore Our Executive Search Solutions" />
              </div>
              <div className="flex flex-col justify-center lg:items-start">
                <p className="md:text-lg text-base textblack mb-6">Leadership Experts Who Combine Insight, Science, And Business  Judgement To Discover Leaders Who Shape The Future.</p>
                {/* <div className="flex justify-center md:justify-start items-center md:items-center gap-4 md:w-64 w-full">
                  <Button text="View All Services" onClick={handleScrollToForm} />
                </div> */}
              </div>
            </div>

            {/* Services Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
              {JsonData.servicesData.map((service) => (
                <div key={service.id} className="group service-card bg-white rounded-2xl p-8 border transition hover:shadow-lg">
                  <div className="mb-6 bg-[#9B26350F] w-24 h-24 rounded-full flex items-center justify-center">
                    <img src={service.icon} alt={service.title} className="w-16 h-16" />
                  </div>
                  <h2 className="text-xl textblack group-hover:text-[#9B2635] mb-4">{service.title}</h2>
                  <p className="text-gray-600 leading-relaxed mb-6">{service.description}</p>
                  {/* <ButtonReadmore text="Read More" /> */}
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Why GregandAllen */}
        <section className="bg-cover py-16 bg-no-repeat bg-center w-full h-auto bgpagecolor" style={{ backgroundImage: "url('/img/assets/home/why-allen-and-donald.webp')", }}>
          <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-[80%] xl:w-11/12">
            <div className="max-w-2xl textwhite">
              <TagHeading className="textwhite" text="Why GregandAllen" />
              <Heading className="textwhite" text="Why Organizations Choose GregandAllen" />
              <p className="md:text-lg text-base textwhite mt-5 mb-10">Because Leadership Decisions Deserve Depth, Science, And Trust.</p>
              <div className="space-y-6">
                {JsonData.organizationsChoose.map((item, index) => (
                  <div key={index} className="flex items-center gap-5 border-b last:border-none border-white/30 pb-6">
                    <div className="w-20 h-20 sm:w-20 sm:h-20 flex-shrink-0 flex items-center justify-center border border-white/40 rounded-lg">
                      <img src={item.icon} alt={item.title} className="w-16 h-16 sm:w-16 sm:h-16 object-contain" />
                    </div>
                    <div>
                      <h1 className="md:text-xl text-lg font-semibold mb-1">{item.title}</h1>
                      <p className="textwhite/80 text-sm">{item.description}</p>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </section>

        <Different />

        <div className="bg-[#fbf4f2] py-24">
          <div className="mx-auto w-full 2xl:w-[80%] xl:w-11/12 px-4">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 pb-6 z-10">
              <div className="">
                <TagHeading className="textactive" text="Our Focus" />
                <Heading className="textblack" text="Leadership Roles We Search For" />
              </div>
              <div className="flex flex-col justify-center">
                <p className="textblack text-lg mb-6"> We identify leaders who shape outcomes, culture, and growth.</p>
              </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 pb-6 z-10">
              <div className="flex-1">
                <img src="/img/assets/home/leadership-roles-we-search-for.webp" alt="Leadership discussion" className="lg:w-[80%] w-full h-auto object-cover rounded-tl-xl rounded-bl-xl rounded-br-xl" />
              </div>
              <div className="w-full flex flex-col lg:pt-0 pt-10">
                <div className="grid grid-cols-2 gap-x-12 gap-y-10">
                  {JsonData.rolesData.map((item) => (
                    <div key={item.id} className="flex flex-col gap-4">
                      <img src={item.icon} alt={item.alt} className="w-20 h-20" />
                      <p className="font-medium text-gray-900">{item.title}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>


          </div>
        </div>

        <div ref={formRef} className="">
          <Methodology />
        </div>

        <section className="bg-[#f9fbfc] py-24">
          <div className="mx-auto w-full 2xl:w-[80%] xl:w-11/12 px-4">

            {/* HEADER */}
            <div className="text-center max-w-2xl mx-auto">
              <TagHeading className="textactive" text="Our Commitment" />
              <Heading className="textblack" text="Our Commitment" />
              <p className="mt-4 text-xl textblack font-semibold">We bring you in touch with the leaders who:</p>
            </div>

            {/* CONTENT GRID */}
            <div className="mt-20 grid grid-cols-1 lg:grid-cols-12 gap-y-16 gap-x-12 items-center">
              <div className="lg:col-span-4 lg:px-10 px-0 space-y-16">
                <div>
                  <div className="flex items-start gap-2 text-xl font-semibold text-gray-900">
                    <h2 className="shrink-0">1.</h2>
                    <h2>Leaders Who Inspire Possibility</h2>
                  </div>
                  <p className="pl-6 mt-4 text-sm textblack leading-relaxed">We identify leaders who think beyond today — those who can see the tomorrow, shape strategy, and create clarity in complexity. They expand the horizon of hope, make people believe in possibility.</p>
                </div>
                <div>
                  <div className="flex items-start gap-2 text-xl font-semibold text-gray-900">
                    <h2 className="shrink-0">2.</h2>
                    <h2>Leaders Who Command Trust Through Action</h2>
                  </div>
                  <p className="pl-6 mt-4 text-sm textblack leading-relaxed">Their integrity, clarity, and steadiness make people feel anchored and assured.</p>
                </div>
              </div>

              <div className="lg:col-span-4">
                <div className="">
                  <img src="/img/assets/home/our-commitment.webp" alt="our-commitment" className="rounded-2xl object-cover w-full h-full" />
                </div>
              </div>

              <div className="lg:col-span-4 lg:px-10 px-0 space-y-16">
                <div>
                  <div className="flex items-start gap-2 text-xl font-semibold text-gray-900">
                    <h2 className="shrink-0">3.</h2>
                    <h2>Leaders Who Lead With Compassion</h2>
                  </div>
                  <p className="pl-6 mt-4 text-sm textblack leading-relaxed">They understand people, respect emotions, and build workplaces where excellence becomes everyone’s natural effort.</p>
                </div>
                <div>
                  <div className="flex items-start gap-2 text-xl font-semibold text-gray-900">
                    <h2 className="shrink-0">4.</h2>
                    <h2>Leaders With Wisdom & Stability</h2>
                  </div>
                  <p className="pl-6 mt-4 text-sm textblack leading-relaxed">Their presence brings calm, clarity, and direction — especially when the stakes are high.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* <section className="bg-white py-20">
          <div className="gap-10 mx-auto px-4 xl:px-0 w-full 2xl:w-[80%] xl:w-11/12 relative">
            <div className="text-center mb-16">
              <h2 className="text-4xl font-bold text-gray-900 mb-4">
                Meet Our Experts
              </h2>
              <p className="max-w-3xl mx-auto text-gray-700">
                Leadership Experts Who Combine Insight, Science, And Business
                Judgement To Discover Leaders Who Shape The Future.
              </p>
            </div>
            <button className="experts-prev absolute left-0 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition">
              <MdOutlineArrowBackIos size={28} />
            </button>
            <button className="experts-next absolute right-0 top-1/2 -translate-y-1/2 z-10 w-12 h-12 rounded-full border border-gray-300 flex items-center justify-center hover:bg-gray-100 transition">
              <MdOutlineArrowForwardIos size={28} />
            </button>
            <div className="px-16">
              <Swiper
                modules={[Navigation]}
                navigation={{
                  prevEl: ".experts-prev",
                  nextEl: ".experts-next",
                }}
                spaceBetween={40}
                slidesPerView={1}
                breakpoints={{
                  768: { slidesPerView: 2 },
                  1024: { slidesPerView: 3 },
                }}
              >
                {JsonData.expertsData.map((expert) => (
                  <SwiperSlide key={expert.id}>
                    <div>
                      <div className="rounded-xl overflow-hidden mb-6">
                        <img src={expert.image} alt={expert.name} className="w-full h-64 object-cover" />
                      </div>
                      <h3 className="text-xl font-semibold text-gray-900 mb-1">{expert.name}</h3>
                      <p className="text-xs uppercase tracking-wide text-gray-500 mb-4">{expert.role}</p>
                      <p className="text-gray-700 mb-4 line-clamp-3">{expert.description}</p>
                      <button className="text-red-700 font-semibold inline-flex items-center gap-2 hover:gap-3 transition-all">
                        Read More <span>→</span>
                      </button>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </section> */}

        <ContactForm />

        <Footer />
      </div>
    </>
  );
};


export default Home;
